import { render, staticRenderFns } from "./CommissionsMortgageChart.vue?vue&type=template&id=6879f51d"
import script from "./CommissionsMortgageChart.vue?vue&type=script&lang=js"
export * from "./CommissionsMortgageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports